var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMetamaskLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 69,
    viewBox: "0 0 76 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1906_11395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2384 0L41.6274 23.3678L47.6917 9.5964L74.2384 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83789 0.0273438L28.3135 9.59797L34.0718 23.5499L1.83789 0.0273438Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1148 49.6968L75.5282 49.9624L70.491 66.5346L52.9033 61.845L61.1148 49.6968Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.885 49.6968L23.0661 61.8451L5.5079 66.5349L0.501221 49.9624L14.885 49.6968Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2888 19.9961L33.878 38.4201L16.2522 37.6435L21.2657 30.3187L21.3292 30.2481L33.2888 19.9961Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5286 19.7905L54.6707 30.2488L54.7335 30.3189L59.7472 37.6436L42.1255 38.42L42.5286 19.7905Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5821 49.75L33.2063 57.0119L22.0266 62.2391L23.5821 49.75Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4195 49.749L53.9428 62.2393L42.7944 57.0116L52.4195 49.749Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0403 56.3276L54.3533 61.6326L43.8299 66.476L43.9392 63.2748L43.0403 56.3276Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9566 56.3301L32.0929 63.2225L32.1638 66.4723L21.6157 61.6326L32.9566 56.3301Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6897 40.8247L32.6459 46.8415L22.5808 43.9862L29.6897 40.8247Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.31 40.8252L53.4523 43.9859L43.3545 46.8405L46.31 40.8252Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3517 49.689L22.7247 62.6379L14.0046 49.972L24.3517 49.689Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6492 49.689L61.9966 49.972L53.2437 62.6383L51.6492 49.689Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.002 36.9111L52.4716 44.3433L46.6658 41.7739L43.886 47.433L42.0637 37.7015L60.002 36.9111Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 36.9111L33.9355 37.7016L32.1133 47.4332L29.333 41.7748L23.5577 44.3436L15.9941 36.9111Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4866 35.3862L24.0064 43.7585L24.3016 52.0238L15.4866 35.3862Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.522 35.3711L51.6912 52.0384L52.0236 43.7583L60.522 35.3711Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5192 35.896L33.8621 37.9861L34.7094 43.193L34.1647 59.1853L31.5892 46.3385L31.5884 46.2057L33.5192 35.896Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4763 35.8672L44.4122 46.2057L44.4114 46.3385L41.8295 59.2174L41.7273 55.9961L41.3245 43.0983L42.4763 35.8672Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.781 43.4258L52.4927 50.6069L43.5051 57.3883L41.6882 56.1451L43.7248 45.9862L52.781 43.4258Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2502 43.4258L32.2752 45.9862L34.3117 56.145L32.4948 57.3881L23.5068 50.6062L23.2502 43.4258Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.896 60.0464L31.3946 65.3226L31.3459 63.0695L32.308 62.2517H43.6883L44.6853 63.0668L44.6118 65.3182L56.0374 60.0597L50.4777 64.5089L43.7548 68.9807H32.2158L25.4973 64.4907L19.896 60.0464Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2168 55.6255L43.8425 56.7376L44.7953 64.099L43.4165 62.9716H32.5879L31.2354 64.1217L32.1568 56.7382L33.7831 55.6255H42.2168Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0856 0.646973L76.0001 12.0197L73.5554 23.5187L75.2962 24.8193L72.9406 26.5598L74.7109 27.8838L72.3667 29.9514L73.8059 30.9607L69.9864 35.2807L54.3203 30.8634L54.1846 30.7929L42.8953 21.5703L72.0856 0.646973Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9146 0.646973L33.105 21.5703L21.8157 30.7929L21.6799 30.8634L6.01372 35.2807L2.19427 30.9607L3.63235 29.9521L1.28918 27.8838L3.0562 26.5612L0.665397 24.8157L2.47187 23.5144L0 12.0202L3.9146 0.646973Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5538 29.8975L70.153 34.5776L75.5458 50.6735L61.3185 50.6734L51.5154 50.7932L58.6446 37.3359L53.5538 29.8975Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4462 29.8975L17.3544 37.3359L24.4846 50.7932L14.6863 50.6735H0.484131L5.84669 34.5777L22.4462 29.8975Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5046 9.51953L43.8617 21.6632L42.8764 38.0682L42.4994 43.21L42.4695 56.3452H33.5302L33.5012 43.2346L33.123 38.0636L32.1373 21.6632L27.4951 9.51953H48.5046Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1906_11395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 69,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamaskLarge);
export default __webpack_public_path__ + "static/media/icon-metamask-large.648cc8fae849d88b8b9bfd5b77dc096b.svg";
export { ForwardRef as ReactComponent };